import type {SanityKey} from './types'

export const SANITY_KEYS: SanityKey[] = [
  '_createdAt',
  '_dataset',
  '_id',
  '_key',
  '_originalId',
  '_projectId',
  '_ref',
  '_rev',
  '_strengthenOnPublish',
  '_type',
  '_updatedAt',
  '_weak',
]
